import actions from './actions';

const {
  CREATE_BANNER_BEGIN,
  CREATE_BANNER_SUCCESS,
  CREATE_BANNER_ERR,
  LIST_BANNERS_BEGIN,
  LIST_BANNERS_SUCCESS,
  LIST_BANNERS_ERR,
  GET_BANNER_DETAILS_BEGIN,
  GET_BANNER_DETAILS_SUCCESS,
  GET_BANNER_DETAILS_ERR,
  UPDATE_BANNER_BEGIN,
  UPDATE_BANNER_SUCCESS,
  UPDATE_BANNER_ERR,
  DELETE_BANNER_BEGIN,
  DELETE_BANNER_SUCCESS,
  DELETE_BANNER_ERR,
  ENABLE_BANNER_BEGIN,
  ENABLE_BANNER_SUCCESS,
  ENABLE_BANNER_ERR,
  DISABLE_BANNER_BEGIN,
  DISABLE_BANNER_SUCCESS,
  DISABLE_BANNER_ERR,
} = actions;

const initState = {
  loadingCreateBanner: false,
  errorCreateBanner: '',
  banners: [],
  loadingListBanners: false,
  errorListBanners: '',
  loadingUpdateBanner: false,
  errorUpdateBanner: '',
  loadingGetBannerDetails: false,
  errorGetBannerDetails: '',
  bannerDetails: {},
  loadingDeleteBanner: false,
  errorDeleteBanner: '',
  loadingEnableBanner: false,
  errorEnableBanner: '',
  loadingDisableBanner: false,
  errorDisableBanner: '',
};

const bannerReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case CREATE_BANNER_BEGIN:
      return {
        ...state,
        loadingCreateBanner: true,
        errorCreateBanner: '',
      };
    case CREATE_BANNER_SUCCESS:
      return {
        ...state,
        banners: [...state.banners, data],
        loadingCreateBanner: false,
        errorCreateBanner: '',
      };
    case CREATE_BANNER_ERR:
      return {
        ...state,
        errorCreateBanner: err,
        loadingCreateBanner: false,
      };

    case LIST_BANNERS_BEGIN:
      return {
        ...state,
        loadingListBanners: true,
        errorListBanners: null,
      };
    case LIST_BANNERS_SUCCESS:
      return {
        ...state,
        banners: [...data],
        loadingListBanners: false,
        errorListBanners: null,
      };
    case LIST_BANNERS_ERR:
      return {
        ...state,
        errorListBanners: err,
        loadingListBanners: false,
      };

    case GET_BANNER_DETAILS_BEGIN:
      return {
        ...state,
        bannerDetails: {},
        loadingGetBannerDetails: true,
        errorGetBannerDetails: null,
      };
    case GET_BANNER_DETAILS_SUCCESS:
      return {
        ...state,
        bannerDetails: data,
        loadingGetBannerDetails: false,
        errorGetBannerDetails: null,
      };
    case GET_BANNER_DETAILS_ERR:
      return {
        ...state,
        bannerDetails: {},
        loadingGetBannerDetails: false,
        errorGetBannerDetails: err,
      };

    case UPDATE_BANNER_BEGIN:
      return {
        ...state,
        loadingUpdateBanner: true,
        errorUpdateBanner: null,
      };
    case UPDATE_BANNER_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const updatedList = state.banners.map((item) => (item.banner_id === data.banner_id ? data : item));

      return {
        ...state,
        banners: [...updatedList],
        loadingUpdateBanner: false,
        errorUpdateBanner: null,
      };
    case UPDATE_BANNER_ERR:
      return {
        ...state,
        errorUpdateBanner: err,
        loadingUpdateBanner: false,
      };

    case DELETE_BANNER_BEGIN:
      return {
        ...state,
        loadingDeleteBanner: true,
        errorDeleteBanner: null,
      };
    case DELETE_BANNER_SUCCESS:
      return {
        ...state,
        loadingDeleteBanner: false,
        errorDeleteBanner: null,
      };
    case DELETE_BANNER_ERR:
      return {
        ...state,
        errorDeleteBanner: err,
        loadingDeleteBanner: false,
      };

    case ENABLE_BANNER_BEGIN:
      return {
        ...state,
        loadingEnableBanner: true,
        errorEnableBanner: null,
      };
    case ENABLE_BANNER_SUCCESS:
      return {
        ...state,
        loadingEnableBanner: false,
        errorEnableBanner: null,
      };
    case ENABLE_BANNER_ERR:
      return {
        ...state,
        errorEnableBanner: err,
        loadingEnableBanner: false,
      };

    case DISABLE_BANNER_BEGIN:
      return {
        ...state,
        loadingDisableBanner: true,
        errorDisableBanner: null,
      };
    case DISABLE_BANNER_SUCCESS:
      return {
        ...state,
        loadingDisableBanner: false,
        errorDisableBanner: null,
      };
    case DISABLE_BANNER_ERR:
      return {
        ...state,
        errorDisableBanner: err,
        loadingDisableBanner: false,
      };

    default:
      return state;
  }
};

export { bannerReducer };
